import { DisplayCaptureState } from "../states";
import { DisplayCaptureActions } from "../actions/displayCapture";
import { ActionTypes } from "../actions";

const getInitialState = (): DisplayCaptureState => {
  return {
    state: null,
    error: null,
    direction: null,
  };
};

const displayCapture = (
  state = getInitialState(),
  action: ActionTypes
): DisplayCaptureState => {
  switch (action.type) {
    case DisplayCaptureActions.DISPLAY_CAPTURE_STATE_CHANGE:
      return { ...state, state: action.payload };
    case DisplayCaptureActions.DISPLAY_CAPTURE_ERROR:
      return { ...state, error: action.payload };
    case DisplayCaptureActions.DISPLAY_CAPTURE_DIRECTION_CHANGE:
      return { ...state, direction: action.payload };
  }
  return state;
};

export default displayCapture;
